<div class="list-filter-single d-flex align-content-center" *ngIf="showClearFilters">
  <div class="list-filter-clearAll" (click)="clear()">
    <span class="list-filter-single_clear">×</span>
    <span class="ml-2">{{ 'List.Filters.clearFilters' | translate }}</span>
  </div>
</div>
